import Avatar from '../../../components/ui/Avatar'
import type { DashboardActionAssignee } from '../types'

interface Props {
  assignees: DashboardActionAssignee[]
}

/**
 * Pano tablolarının **"Sorumlu" / "Atanan Yönetici"** hücresi: baş harf rozeti + ad. Bir aksiyon birden
 * çok kişiye atanmış olabilir; hepsi listelenir (satır sayısı artmaz).
 *
 * <p>Rozet rengi <b>sicilden</b> türer, satır sırasından değil → aynı kişi her sayfada aynı renktedir.
 *
 * <p>Atanansız aksiyonda hücre <b>boş</b> bırakılır (053/FR-011c) — yer tutucu yazılmaz.
 *
 * <p>İki tablo (Yönetici Raporu'nun alt tablosu ve Raporum'un "Aksiyon Beklenen Maddeler"i) aynı hücreyi
 * çizdiği için bileşen ortaktır (Reuse Mandate): rozet rengi/ad biçimi tek yerde değişir.
 */
export default function DashboardAssigneeCell({ assignees }: Readonly<Props>) {
  if (assignees.length === 0) return null
  return (
    <span className="home-assignees">
      {assignees.map((a) => (
        <span key={a.employeeId} className="home-assignee">
          <Avatar name={a.fullName} />
          <span style={{ fontSize: '12px' }}>{a.fullName}</span>
        </span>
      ))}
    </span>
  )
}
